var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "lc-vote",
        _vm.isVoted ? "lc-vote-voted" : "",
        _vm.isCompact ? "" : "lc-vote-fill-width",
        _vm.voting_enabled ? "" : "d-none"
      ]
    },
    [
      _c("div", { staticClass: "lc-vote-text" }, [
        _vm._v(_vm._s(_vm.isVoted ? _vm.trans("voted") : _vm.trans("vote")))
      ]),
      _c(
        "div",
        { class: ["lc-vote-stars", { "can-vote": !_vm.isVoted | _vm.isJury }] },
        _vm._l([0, 1, 2, 3, 4], function(i) {
          return _c("div", {
            key: i,
            class: [
              "lc-vote-star",
              { "lc-vote-star-active": i < _vm.currentRanking },
              { "lc-vote-animate": i == _vm.animateIndex }
            ],
            on: {
              mouseover: function($event) {
                _vm.maxHovered = i
              },
              mouseleave: function($event) {
                _vm.maxHovered = -1
              },
              click: function($event) {
                return _vm.vote(i + 1)
              }
            }
          })
        }),
        0
      ),
      _vm.currentPosition > 0 && !_vm.isCompact
        ? _c("div", { staticClass: "currentPosition" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.trans("position")) +
                  " " +
                  _vm._s(_vm.currentPosition)
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }